import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

const Label = ({ brand, content, name }) => (
  h.span(h.ca('label', 'lc', brand),
    name && h.span(h.ca(styles.name), name),
    h.span(null, content)))

export default class Labels extends Component {
  render () {
    const { labels } = this.props

    return h.div(null,
      labels.filter(a => a).map((props, i) => h.h(Label, { key: i, ...props })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Labels/index.js